/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Property, type PropertyValue } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { getPath } from '@/utils/next-util'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { FilterGeneral } from './FilterGeneral'
import { FilterItem } from './FilterItem'

export interface FilterList {
  properties: Property[]
  onChange: (params: any) => void
  activeFilters: {
    name: string
    values: PropertyValue[] | string[]
    value: any
    data: PropertyValue[]
  }[]
}
interface FilterDataProps {
  name: string
  values: PropertyValue[] | string[]
  value: any
  data: PropertyValue[]
}
export const FilterList = ({
  properties,
  activeFilters = [],
  onChange = () => true,
}: FilterList) => {
  const [filterData, setFilterData] = useState<FilterDataProps[]>([])
  const [fetchFilter, setFetchFilter] = useState(false)
  const router = useRouter()
  useEffect(() => {
    setFilterData(activeFilters)
  }, [router, fetchFilter])
  const onSubmitFilter = async () => {
    onChange(filterData)
  }
  const updateValues = async (
    oldArr: {
      name: string
      values: PropertyValue[] | string[]
      value: any
      data: PropertyValue[]
    }[],
    newArr: {
      name: string
      values: PropertyValue[] | string[]
      value: any
      data: PropertyValue[]
    }[]
  ) => {
    newArr.forEach(newObj => {
      const index = oldArr.findIndex(item => item.name === newObj.name)

      if (index !== -1) {
        if (newObj.values.length > 0) {
          oldArr[index].values = newObj.values
        } else {
          oldArr[index].values = []
        }

        if (newObj.values.length > 0) {
          oldArr[index].value = newObj.values.join(',')
        } else {
          oldArr[index].value = null
        }
      }
    })
  }
  const selectedFilterByKey = async (e: any[]) => {
    const newFilter = filterData
    await updateValues(newFilter, e)
    setFilterData([...newFilter])
    setFetchFilter(true)
  }

  return (
    <div className={`flex gap-x-2.5 gap-y-1`}>
      <FilterGeneral
        properties={properties}
        onChange={onSubmitFilter}
        filterData={filterData}
        setFilterData={setFilterData}
        fetchFilter={fetchFilter}
        setFetchFilter={setFetchFilter}
      />
      {properties &&
        properties.map((e: Property, i: number) => (
          <FilterItem
            key={e._id}
            filterGroup={e}
            filterKey={getPath(e.slugs)}
            index={i}
            selectedFilterByKey={selectedFilterByKey}
            className='mb-1.5'
            onChange={onSubmitFilter}
            filterData={filterData}
            setFilterData={setFilterData}
            fetchFilter={fetchFilter}
            setFetchFilter={setFetchFilter}
            title={getTranslate(e.displayName)}
          />
        ))}
    </div>
  )
}
